import { render, staticRenderFns } from "./PublishEditionChannelModal.vue?vue&type=template&id=b09f12b2&scoped=true"
import script from "./PublishEditionChannelModal.vue?vue&type=script&lang=js"
export * from "./PublishEditionChannelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09f12b2",
  null
  
)

export default component.exports